import { BaseWebComponentTranslator } from '../../../../../framework/BaseWebComponentTranslator';
import {
  CoolDownPeriodMonths,
  InProductTrialCannotBeStartedReason,
} from '../../../../b2b/types/InProductTrialCannotBeStartedReason';
import { Button } from '../../types';
import { MspInProductTrialCannotBeStartedReason } from '../../../../../company/common/mspInProductTrialsTab/types/msp-in-product-trials-types';

export enum GzLandingPageButtonId {
  FreeTrial = 'FreeTrialButtonId',
  RequestTrial = 'RequestTrialButtonId',
  ViewDemo = 'ViewDemoButtonId',
  HowTo = 'HowToButtonId',
  StopTrial = 'StopTrialButtonId',
}

// get settings for buttons
export function getButtonsSettingsForProductItem(translator: BaseWebComponentTranslator): {
  tooltipTextMapping: { [reason in InProductTrialCannotBeStartedReason]: string };
  button1: Button;
  button2: Button;
  button3: Button;
  button4: Button;
  button5: Button;
  button6: Button;
} {
  return {
    tooltipTextMapping: {
      [InProductTrialCannotBeStartedReason.AlreadyStartedForCurrentProduct]: '',
      [InProductTrialCannotBeStartedReason.AlreadyStartedForAnotherProduct]: translator.translateFn(
        'A product trial is already active.'
      ),
      [InProductTrialCannotBeStartedReason.CoolDownNotPassedForStart]: translator.translateFn(
        'You cannot start another product trial until the {coolDownPeriodMonths} months cool down period has passed.',
        {
          coolDownPeriodMonths: CoolDownPeriodMonths,
        }
      ),
      [InProductTrialCannotBeStartedReason.NotEnoughDaysForCurrentProduct]: translator.translateFn(
        'Not enough days remaining in your current subscription for you to start a trial.'
      ),
      [InProductTrialCannotBeStartedReason.CoolDownNotPassedForRequest]: translator.translateFn(
        'A request has already been made for this company. We will be in touch shortly.'
      ),
    },
    button1: {
      buttonText: translator.translateFn('Start Free Trial'),
      buttonId: GzLandingPageButtonId.FreeTrial,
    },
    button2: {
      buttonText: translator.translateFn('View Demo'),
      buttonId: GzLandingPageButtonId.ViewDemo,
    },
    button3: {
      buttonText: translator.translateFn('How to'),
      buttonId: GzLandingPageButtonId.HowTo,
    },
    button4: {
      buttonText: translator.translateFn('Stop trial'),
      buttonId: GzLandingPageButtonId.StopTrial,
    },
    button5: {
      buttonText: translator.translateFn('Contact us'),
      buttonId: GzLandingPageButtonId.RequestTrial,
    },
    button6: {
      buttonText: translator.translateFn('Request a trial'),
      buttonId: GzLandingPageButtonId.RequestTrial,
    },
  };
}

// get settings for buttons MSP case

export function getButtonSettingsForMsp(translator: BaseWebComponentTranslator): {
  tooltipTextMapping: { [reason in MspInProductTrialCannotBeStartedReason]: string };
  startButton: Button;
  demoButton: Button;
  howToButton: Button;
  stopButton: Button;
} {
  return {
    tooltipTextMapping: {
      [MspInProductTrialCannotBeStartedReason.TrialValid]: '',
      [MspInProductTrialCannotBeStartedReason.ParentDoesNotResellProduct]: translator.translateFn(
        'Unable to enroll. The Partner that manages this company does not provide this feature.'
      ),
      [MspInProductTrialCannotBeStartedReason.CompanyDoesNotHaveEndpointSecurityAsProductType]: translator.translateFn(
        'Only companies using the Endpoint Security product type are eligible for Product Trials.'
      ),
      [MspInProductTrialCannotBeStartedReason.StatusIsNotAvailable]: translator.translateFn(
        'Unable to start trial. Please contact Bitdefender Enterprise Support.'
      ),
      [MspInProductTrialCannotBeStartedReason.TrialAlreadyInProgressForCurrentProduct]: translator.translateFn(
        ''
      ),
      [MspInProductTrialCannotBeStartedReason.TrialAlreadyInProgressForAnotherProduct]: translator.translateFn(
        'A product trial is already in progress for this company.'
      ),
      [MspInProductTrialCannotBeStartedReason.InCooldown]: translator.translateFn(
        'Unable to start trial. You must wait 180 days after the last trial ended.'
      ),
      [MspInProductTrialCannotBeStartedReason.CompanyIsSuspended]: translator.translateFn(
        'You cannot start a product trial for a suspended company.'
      ),
      [MspInProductTrialCannotBeStartedReason.ParentCompanyDoesNotDelegateTrialFeature]: translator.translateFn(
        'Unable to start trial. Please contact your Bitdefender sales representative.'
      ),
      [MspInProductTrialCannotBeStartedReason.CompanyDoesNotBelongInAnEligibleTreeHierarchy]: translator.translateFn(
        'Unable to start trial. Please contact your Bitdefender sales representative.'
      ),
      [MspInProductTrialCannotBeStartedReason.UserHasNoManageInventoryRight]: translator.translateFn(
        'Unable to start trial. You need Manage Networks user rights.'
      ),
      [MspInProductTrialCannotBeStartedReason.ParentCompanyHasNoContact]: translator.translateFn(
        "To enable the MDR service, the company's Partner must have the MDR service with an Active or Onboarding status."
      )
    },
    startButton: {
      buttonText: translator.translateFn('Start Free Trial'),
      buttonId: GzLandingPageButtonId.FreeTrial,
    },
    demoButton: {
      buttonText: translator.translateFn('View Demo'),
      buttonId: GzLandingPageButtonId.ViewDemo,
    },
    howToButton: {
      buttonText: translator.translateFn('How to'),
      buttonId: GzLandingPageButtonId.HowTo,
    },
    stopButton: {
      buttonText: translator.translateFn('Stop trial'),
      buttonId: GzLandingPageButtonId.StopTrial,
    },
  };
}
